import React, { forwardRef, useRef } from "react";
import clsx from "clsx";

import styles from "./CartItemQuantityWidget.module.scss";
import InteractiveDiv from "../support/InteractiveDiv";
import QuantityModifier from "../support/QuantityModifier";

function CartItemQuantityWidget() {
  const quantityWidgetRef = useRef<HTMLDivElement>(null);

  return (
    <InteractiveDiv
      className={clsx(styles.quantityModifier)}
      ref={quantityWidgetRef}
    >
      <QuantityModifier withRemoveOption value={1} min={0} />
    </InteractiveDiv>
  );
}

export default forwardRef(CartItemQuantityWidget);
